export default "__VITE_ASSET__DRxGDn9I__"